/**
 * @fileoverview gRPC-Web generated client stub for risk
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.20.3
// source: risk/risk.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var google_protobuf_wrappers_pb = require('google-protobuf/google/protobuf/wrappers_pb.js')

var common_model_pb = require('../common/model_pb.js')

var authz_annotations_pb = require('../authz/annotations_pb.js')
const proto = {};
proto.risk = require('./risk_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.risk.RiskServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.risk.RiskServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.risk.GetRisksRequest,
 *   !proto.risk.GetRisksResponse>}
 */
const methodDescriptor_RiskService_GetRisks = new grpc.web.MethodDescriptor(
  '/risk.RiskService/GetRisks',
  grpc.web.MethodType.UNARY,
  proto.risk.GetRisksRequest,
  proto.risk.GetRisksResponse,
  /**
   * @param {!proto.risk.GetRisksRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.risk.GetRisksResponse.deserializeBinary
);


/**
 * @param {!proto.risk.GetRisksRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.risk.GetRisksResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.risk.GetRisksResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.risk.RiskServiceClient.prototype.getRisks =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/risk.RiskService/GetRisks',
      request,
      metadata || {},
      methodDescriptor_RiskService_GetRisks,
      callback);
};


/**
 * @param {!proto.risk.GetRisksRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.risk.GetRisksResponse>}
 *     Promise that resolves to the response
 */
proto.risk.RiskServicePromiseClient.prototype.getRisks =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/risk.RiskService/GetRisks',
      request,
      metadata || {},
      methodDescriptor_RiskService_GetRisks);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.risk.GetRisksByIdsRequest,
 *   !proto.risk.GetRisksResponse>}
 */
const methodDescriptor_RiskService_GetRisksByIds = new grpc.web.MethodDescriptor(
  '/risk.RiskService/GetRisksByIds',
  grpc.web.MethodType.UNARY,
  proto.risk.GetRisksByIdsRequest,
  proto.risk.GetRisksResponse,
  /**
   * @param {!proto.risk.GetRisksByIdsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.risk.GetRisksResponse.deserializeBinary
);


/**
 * @param {!proto.risk.GetRisksByIdsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.risk.GetRisksResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.risk.GetRisksResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.risk.RiskServiceClient.prototype.getRisksByIds =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/risk.RiskService/GetRisksByIds',
      request,
      metadata || {},
      methodDescriptor_RiskService_GetRisksByIds,
      callback);
};


/**
 * @param {!proto.risk.GetRisksByIdsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.risk.GetRisksResponse>}
 *     Promise that resolves to the response
 */
proto.risk.RiskServicePromiseClient.prototype.getRisksByIds =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/risk.RiskService/GetRisksByIds',
      request,
      metadata || {},
      methodDescriptor_RiskService_GetRisksByIds);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.risk.CreateOrUpdateRisksRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_RiskService_CreateOrUpdateRisks = new grpc.web.MethodDescriptor(
  '/risk.RiskService/CreateOrUpdateRisks',
  grpc.web.MethodType.UNARY,
  proto.risk.CreateOrUpdateRisksRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.risk.CreateOrUpdateRisksRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.risk.CreateOrUpdateRisksRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.risk.RiskServiceClient.prototype.createOrUpdateRisks =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/risk.RiskService/CreateOrUpdateRisks',
      request,
      metadata || {},
      methodDescriptor_RiskService_CreateOrUpdateRisks,
      callback);
};


/**
 * @param {!proto.risk.CreateOrUpdateRisksRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.risk.RiskServicePromiseClient.prototype.createOrUpdateRisks =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/risk.RiskService/CreateOrUpdateRisks',
      request,
      metadata || {},
      methodDescriptor_RiskService_CreateOrUpdateRisks);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.risk.ImportRisksRequest,
 *   !proto.risk.ImportRisksResponse>}
 */
const methodDescriptor_RiskService_ImportRisks = new grpc.web.MethodDescriptor(
  '/risk.RiskService/ImportRisks',
  grpc.web.MethodType.UNARY,
  proto.risk.ImportRisksRequest,
  proto.risk.ImportRisksResponse,
  /**
   * @param {!proto.risk.ImportRisksRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.risk.ImportRisksResponse.deserializeBinary
);


/**
 * @param {!proto.risk.ImportRisksRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.risk.ImportRisksResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.risk.ImportRisksResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.risk.RiskServiceClient.prototype.importRisks =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/risk.RiskService/ImportRisks',
      request,
      metadata || {},
      methodDescriptor_RiskService_ImportRisks,
      callback);
};


/**
 * @param {!proto.risk.ImportRisksRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.risk.ImportRisksResponse>}
 *     Promise that resolves to the response
 */
proto.risk.RiskServicePromiseClient.prototype.importRisks =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/risk.RiskService/ImportRisks',
      request,
      metadata || {},
      methodDescriptor_RiskService_ImportRisks);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.risk.DeleteRisksRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_RiskService_DeleteRisks = new grpc.web.MethodDescriptor(
  '/risk.RiskService/DeleteRisks',
  grpc.web.MethodType.UNARY,
  proto.risk.DeleteRisksRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.risk.DeleteRisksRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.risk.DeleteRisksRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.risk.RiskServiceClient.prototype.deleteRisks =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/risk.RiskService/DeleteRisks',
      request,
      metadata || {},
      methodDescriptor_RiskService_DeleteRisks,
      callback);
};


/**
 * @param {!proto.risk.DeleteRisksRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.risk.RiskServicePromiseClient.prototype.deleteRisks =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/risk.RiskService/DeleteRisks',
      request,
      metadata || {},
      methodDescriptor_RiskService_DeleteRisks);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.risk.ToggleRiskLinksRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_RiskService_ToggleRiskLinks = new grpc.web.MethodDescriptor(
  '/risk.RiskService/ToggleRiskLinks',
  grpc.web.MethodType.UNARY,
  proto.risk.ToggleRiskLinksRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.risk.ToggleRiskLinksRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.risk.ToggleRiskLinksRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.risk.RiskServiceClient.prototype.toggleRiskLinks =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/risk.RiskService/ToggleRiskLinks',
      request,
      metadata || {},
      methodDescriptor_RiskService_ToggleRiskLinks,
      callback);
};


/**
 * @param {!proto.risk.ToggleRiskLinksRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.risk.RiskServicePromiseClient.prototype.toggleRiskLinks =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/risk.RiskService/ToggleRiskLinks',
      request,
      metadata || {},
      methodDescriptor_RiskService_ToggleRiskLinks);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.risk.DownloadRiskCSVResponse>}
 */
const methodDescriptor_RiskService_DownloadRiskCSV = new grpc.web.MethodDescriptor(
  '/risk.RiskService/DownloadRiskCSV',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.risk.DownloadRiskCSVResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.risk.DownloadRiskCSVResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.risk.DownloadRiskCSVResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.risk.DownloadRiskCSVResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.risk.RiskServiceClient.prototype.downloadRiskCSV =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/risk.RiskService/DownloadRiskCSV',
      request,
      metadata || {},
      methodDescriptor_RiskService_DownloadRiskCSV,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.risk.DownloadRiskCSVResponse>}
 *     Promise that resolves to the response
 */
proto.risk.RiskServicePromiseClient.prototype.downloadRiskCSV =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/risk.RiskService/DownloadRiskCSV',
      request,
      metadata || {},
      methodDescriptor_RiskService_DownloadRiskCSV);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.risk.GetRiskCategoryOptionResponse>}
 */
const methodDescriptor_RiskService_GetRiskCategoryOption = new grpc.web.MethodDescriptor(
  '/risk.RiskService/GetRiskCategoryOption',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.risk.GetRiskCategoryOptionResponse,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.risk.GetRiskCategoryOptionResponse.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.risk.GetRiskCategoryOptionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.risk.GetRiskCategoryOptionResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.risk.RiskServiceClient.prototype.getRiskCategoryOption =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/risk.RiskService/GetRiskCategoryOption',
      request,
      metadata || {},
      methodDescriptor_RiskService_GetRiskCategoryOption,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.risk.GetRiskCategoryOptionResponse>}
 *     Promise that resolves to the response
 */
proto.risk.RiskServicePromiseClient.prototype.getRiskCategoryOption =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/risk.RiskService/GetRiskCategoryOption',
      request,
      metadata || {},
      methodDescriptor_RiskService_GetRiskCategoryOption);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.risk.UpsertRiskCategoryOptionRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_RiskService_UpsertRiskCategoryOption = new grpc.web.MethodDescriptor(
  '/risk.RiskService/UpsertRiskCategoryOption',
  grpc.web.MethodType.UNARY,
  proto.risk.UpsertRiskCategoryOptionRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.risk.UpsertRiskCategoryOptionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.risk.UpsertRiskCategoryOptionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.risk.RiskServiceClient.prototype.upsertRiskCategoryOption =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/risk.RiskService/UpsertRiskCategoryOption',
      request,
      metadata || {},
      methodDescriptor_RiskService_UpsertRiskCategoryOption,
      callback);
};


/**
 * @param {!proto.risk.UpsertRiskCategoryOptionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.risk.RiskServicePromiseClient.prototype.upsertRiskCategoryOption =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/risk.RiskService/UpsertRiskCategoryOption',
      request,
      metadata || {},
      methodDescriptor_RiskService_UpsertRiskCategoryOption);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.risk.DeleteRiskCategoryOptionRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_RiskService_DeleteRiskCategoryOption = new grpc.web.MethodDescriptor(
  '/risk.RiskService/DeleteRiskCategoryOption',
  grpc.web.MethodType.UNARY,
  proto.risk.DeleteRiskCategoryOptionRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.risk.DeleteRiskCategoryOptionRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.risk.DeleteRiskCategoryOptionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.risk.RiskServiceClient.prototype.deleteRiskCategoryOption =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/risk.RiskService/DeleteRiskCategoryOption',
      request,
      metadata || {},
      methodDescriptor_RiskService_DeleteRiskCategoryOption,
      callback);
};


/**
 * @param {!proto.risk.DeleteRiskCategoryOptionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.risk.RiskServicePromiseClient.prototype.deleteRiskCategoryOption =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/risk.RiskService/DeleteRiskCategoryOption',
      request,
      metadata || {},
      methodDescriptor_RiskService_DeleteRiskCategoryOption);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.risk.SetRiskAssigneesRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_RiskService_SetAssignees = new grpc.web.MethodDescriptor(
  '/risk.RiskService/SetAssignees',
  grpc.web.MethodType.UNARY,
  proto.risk.SetRiskAssigneesRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.risk.SetRiskAssigneesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.risk.SetRiskAssigneesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.risk.RiskServiceClient.prototype.setAssignees =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/risk.RiskService/SetAssignees',
      request,
      metadata || {},
      methodDescriptor_RiskService_SetAssignees,
      callback);
};


/**
 * @param {!proto.risk.SetRiskAssigneesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.risk.RiskServicePromiseClient.prototype.setAssignees =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/risk.RiskService/SetAssignees',
      request,
      metadata || {},
      methodDescriptor_RiskService_SetAssignees);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.risk.ListRiskEvaluationCriteriaRequest,
 *   !proto.risk.ListRiskEvaluationCriteriaResponse>}
 */
const methodDescriptor_RiskService_ListRiskEvaluationCriteria = new grpc.web.MethodDescriptor(
  '/risk.RiskService/ListRiskEvaluationCriteria',
  grpc.web.MethodType.UNARY,
  proto.risk.ListRiskEvaluationCriteriaRequest,
  proto.risk.ListRiskEvaluationCriteriaResponse,
  /**
   * @param {!proto.risk.ListRiskEvaluationCriteriaRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.risk.ListRiskEvaluationCriteriaResponse.deserializeBinary
);


/**
 * @param {!proto.risk.ListRiskEvaluationCriteriaRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.risk.ListRiskEvaluationCriteriaResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.risk.ListRiskEvaluationCriteriaResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.risk.RiskServiceClient.prototype.listRiskEvaluationCriteria =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/risk.RiskService/ListRiskEvaluationCriteria',
      request,
      metadata || {},
      methodDescriptor_RiskService_ListRiskEvaluationCriteria,
      callback);
};


/**
 * @param {!proto.risk.ListRiskEvaluationCriteriaRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.risk.ListRiskEvaluationCriteriaResponse>}
 *     Promise that resolves to the response
 */
proto.risk.RiskServicePromiseClient.prototype.listRiskEvaluationCriteria =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/risk.RiskService/ListRiskEvaluationCriteria',
      request,
      metadata || {},
      methodDescriptor_RiskService_ListRiskEvaluationCriteria);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.risk.CreateRiskEvaluationCriteriaRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_RiskService_CreateRiskEvaluationCriteria = new grpc.web.MethodDescriptor(
  '/risk.RiskService/CreateRiskEvaluationCriteria',
  grpc.web.MethodType.UNARY,
  proto.risk.CreateRiskEvaluationCriteriaRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.risk.CreateRiskEvaluationCriteriaRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.risk.CreateRiskEvaluationCriteriaRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.risk.RiskServiceClient.prototype.createRiskEvaluationCriteria =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/risk.RiskService/CreateRiskEvaluationCriteria',
      request,
      metadata || {},
      methodDescriptor_RiskService_CreateRiskEvaluationCriteria,
      callback);
};


/**
 * @param {!proto.risk.CreateRiskEvaluationCriteriaRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.risk.RiskServicePromiseClient.prototype.createRiskEvaluationCriteria =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/risk.RiskService/CreateRiskEvaluationCriteria',
      request,
      metadata || {},
      methodDescriptor_RiskService_CreateRiskEvaluationCriteria);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.risk.UpdateRiskEvaluationCriteriaRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_RiskService_UpdateRiskEvaluationCriteria = new grpc.web.MethodDescriptor(
  '/risk.RiskService/UpdateRiskEvaluationCriteria',
  grpc.web.MethodType.UNARY,
  proto.risk.UpdateRiskEvaluationCriteriaRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.risk.UpdateRiskEvaluationCriteriaRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.risk.UpdateRiskEvaluationCriteriaRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.risk.RiskServiceClient.prototype.updateRiskEvaluationCriteria =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/risk.RiskService/UpdateRiskEvaluationCriteria',
      request,
      metadata || {},
      methodDescriptor_RiskService_UpdateRiskEvaluationCriteria,
      callback);
};


/**
 * @param {!proto.risk.UpdateRiskEvaluationCriteriaRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.risk.RiskServicePromiseClient.prototype.updateRiskEvaluationCriteria =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/risk.RiskService/UpdateRiskEvaluationCriteria',
      request,
      metadata || {},
      methodDescriptor_RiskService_UpdateRiskEvaluationCriteria);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.risk.DeleteRiskEvaluationCriteriaRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_RiskService_DeleteRiskEvaluationCriteria = new grpc.web.MethodDescriptor(
  '/risk.RiskService/DeleteRiskEvaluationCriteria',
  grpc.web.MethodType.UNARY,
  proto.risk.DeleteRiskEvaluationCriteriaRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.risk.DeleteRiskEvaluationCriteriaRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.risk.DeleteRiskEvaluationCriteriaRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.risk.RiskServiceClient.prototype.deleteRiskEvaluationCriteria =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/risk.RiskService/DeleteRiskEvaluationCriteria',
      request,
      metadata || {},
      methodDescriptor_RiskService_DeleteRiskEvaluationCriteria,
      callback);
};


/**
 * @param {!proto.risk.DeleteRiskEvaluationCriteriaRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.risk.RiskServicePromiseClient.prototype.deleteRiskEvaluationCriteria =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/risk.RiskService/DeleteRiskEvaluationCriteria',
      request,
      metadata || {},
      methodDescriptor_RiskService_DeleteRiskEvaluationCriteria);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.risk.ListRiskEvaluationCriteriaVersionsRequest,
 *   !proto.risk.ListRiskEvaluationCriteriaVersionsResponse>}
 */
const methodDescriptor_RiskService_ListRiskEvaluationCriteriaVersions = new grpc.web.MethodDescriptor(
  '/risk.RiskService/ListRiskEvaluationCriteriaVersions',
  grpc.web.MethodType.UNARY,
  proto.risk.ListRiskEvaluationCriteriaVersionsRequest,
  proto.risk.ListRiskEvaluationCriteriaVersionsResponse,
  /**
   * @param {!proto.risk.ListRiskEvaluationCriteriaVersionsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.risk.ListRiskEvaluationCriteriaVersionsResponse.deserializeBinary
);


/**
 * @param {!proto.risk.ListRiskEvaluationCriteriaVersionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.risk.ListRiskEvaluationCriteriaVersionsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.risk.ListRiskEvaluationCriteriaVersionsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.risk.RiskServiceClient.prototype.listRiskEvaluationCriteriaVersions =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/risk.RiskService/ListRiskEvaluationCriteriaVersions',
      request,
      metadata || {},
      methodDescriptor_RiskService_ListRiskEvaluationCriteriaVersions,
      callback);
};


/**
 * @param {!proto.risk.ListRiskEvaluationCriteriaVersionsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.risk.ListRiskEvaluationCriteriaVersionsResponse>}
 *     Promise that resolves to the response
 */
proto.risk.RiskServicePromiseClient.prototype.listRiskEvaluationCriteriaVersions =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/risk.RiskService/ListRiskEvaluationCriteriaVersions',
      request,
      metadata || {},
      methodDescriptor_RiskService_ListRiskEvaluationCriteriaVersions);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.risk.EvaluateRiskRequest,
 *   !proto.risk.RiskEvaluationResult>}
 */
const methodDescriptor_RiskService_EvaluateRisk = new grpc.web.MethodDescriptor(
  '/risk.RiskService/EvaluateRisk',
  grpc.web.MethodType.UNARY,
  proto.risk.EvaluateRiskRequest,
  proto.risk.RiskEvaluationResult,
  /**
   * @param {!proto.risk.EvaluateRiskRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.risk.RiskEvaluationResult.deserializeBinary
);


/**
 * @param {!proto.risk.EvaluateRiskRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.risk.RiskEvaluationResult)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.risk.RiskEvaluationResult>|undefined}
 *     The XHR Node Readable Stream
 */
proto.risk.RiskServiceClient.prototype.evaluateRisk =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/risk.RiskService/EvaluateRisk',
      request,
      metadata || {},
      methodDescriptor_RiskService_EvaluateRisk,
      callback);
};


/**
 * @param {!proto.risk.EvaluateRiskRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.risk.RiskEvaluationResult>}
 *     Promise that resolves to the response
 */
proto.risk.RiskServicePromiseClient.prototype.evaluateRisk =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/risk.RiskService/EvaluateRisk',
      request,
      metadata || {},
      methodDescriptor_RiskService_EvaluateRisk);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.risk.ListRiskEvaluationsRequest,
 *   !proto.risk.ListRiskEvaluationsResponse>}
 */
const methodDescriptor_RiskService_ListRiskEvaluations = new grpc.web.MethodDescriptor(
  '/risk.RiskService/ListRiskEvaluations',
  grpc.web.MethodType.UNARY,
  proto.risk.ListRiskEvaluationsRequest,
  proto.risk.ListRiskEvaluationsResponse,
  /**
   * @param {!proto.risk.ListRiskEvaluationsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.risk.ListRiskEvaluationsResponse.deserializeBinary
);


/**
 * @param {!proto.risk.ListRiskEvaluationsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.risk.ListRiskEvaluationsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.risk.ListRiskEvaluationsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.risk.RiskServiceClient.prototype.listRiskEvaluations =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/risk.RiskService/ListRiskEvaluations',
      request,
      metadata || {},
      methodDescriptor_RiskService_ListRiskEvaluations,
      callback);
};


/**
 * @param {!proto.risk.ListRiskEvaluationsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.risk.ListRiskEvaluationsResponse>}
 *     Promise that resolves to the response
 */
proto.risk.RiskServicePromiseClient.prototype.listRiskEvaluations =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/risk.RiskService/ListRiskEvaluations',
      request,
      metadata || {},
      methodDescriptor_RiskService_ListRiskEvaluations);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.risk.RiskStatuses>}
 */
const methodDescriptor_RiskService_ListRiskStatuses = new grpc.web.MethodDescriptor(
  '/risk.RiskService/ListRiskStatuses',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.risk.RiskStatuses,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.risk.RiskStatuses.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.risk.RiskStatuses)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.risk.RiskStatuses>|undefined}
 *     The XHR Node Readable Stream
 */
proto.risk.RiskServiceClient.prototype.listRiskStatuses =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/risk.RiskService/ListRiskStatuses',
      request,
      metadata || {},
      methodDescriptor_RiskService_ListRiskStatuses,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.risk.RiskStatuses>}
 *     Promise that resolves to the response
 */
proto.risk.RiskServicePromiseClient.prototype.listRiskStatuses =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/risk.RiskService/ListRiskStatuses',
      request,
      metadata || {},
      methodDescriptor_RiskService_ListRiskStatuses);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.risk.CreateOrUpdateRiskStatusRequest,
 *   !proto.risk.RiskStatuses>}
 */
const methodDescriptor_RiskService_CreateOrUpdateRiskStatus = new grpc.web.MethodDescriptor(
  '/risk.RiskService/CreateOrUpdateRiskStatus',
  grpc.web.MethodType.UNARY,
  proto.risk.CreateOrUpdateRiskStatusRequest,
  proto.risk.RiskStatuses,
  /**
   * @param {!proto.risk.CreateOrUpdateRiskStatusRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.risk.RiskStatuses.deserializeBinary
);


/**
 * @param {!proto.risk.CreateOrUpdateRiskStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.risk.RiskStatuses)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.risk.RiskStatuses>|undefined}
 *     The XHR Node Readable Stream
 */
proto.risk.RiskServiceClient.prototype.createOrUpdateRiskStatus =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/risk.RiskService/CreateOrUpdateRiskStatus',
      request,
      metadata || {},
      methodDescriptor_RiskService_CreateOrUpdateRiskStatus,
      callback);
};


/**
 * @param {!proto.risk.CreateOrUpdateRiskStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.risk.RiskStatuses>}
 *     Promise that resolves to the response
 */
proto.risk.RiskServicePromiseClient.prototype.createOrUpdateRiskStatus =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/risk.RiskService/CreateOrUpdateRiskStatus',
      request,
      metadata || {},
      methodDescriptor_RiskService_CreateOrUpdateRiskStatus);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.risk.DeleteRiskStatusRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_RiskService_DeleteRiskStatus = new grpc.web.MethodDescriptor(
  '/risk.RiskService/DeleteRiskStatus',
  grpc.web.MethodType.UNARY,
  proto.risk.DeleteRiskStatusRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.risk.DeleteRiskStatusRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.risk.DeleteRiskStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.risk.RiskServiceClient.prototype.deleteRiskStatus =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/risk.RiskService/DeleteRiskStatus',
      request,
      metadata || {},
      methodDescriptor_RiskService_DeleteRiskStatus,
      callback);
};


/**
 * @param {!proto.risk.DeleteRiskStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.risk.RiskServicePromiseClient.prototype.deleteRiskStatus =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/risk.RiskService/DeleteRiskStatus',
      request,
      metadata || {},
      methodDescriptor_RiskService_DeleteRiskStatus);
};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.risk.RiskInternalServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.risk.RiskInternalServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.risk.CreateOrUpdateRisksInternalRequest,
 *   !proto.risk.CreateOrUpdateRisksInternalResponse>}
 */
const methodDescriptor_RiskInternalService_CreateOrUpdateRisks = new grpc.web.MethodDescriptor(
  '/risk.RiskInternalService/CreateOrUpdateRisks',
  grpc.web.MethodType.UNARY,
  proto.risk.CreateOrUpdateRisksInternalRequest,
  proto.risk.CreateOrUpdateRisksInternalResponse,
  /**
   * @param {!proto.risk.CreateOrUpdateRisksInternalRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.risk.CreateOrUpdateRisksInternalResponse.deserializeBinary
);


/**
 * @param {!proto.risk.CreateOrUpdateRisksInternalRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.risk.CreateOrUpdateRisksInternalResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.risk.CreateOrUpdateRisksInternalResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.risk.RiskInternalServiceClient.prototype.createOrUpdateRisks =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/risk.RiskInternalService/CreateOrUpdateRisks',
      request,
      metadata || {},
      methodDescriptor_RiskInternalService_CreateOrUpdateRisks,
      callback);
};


/**
 * @param {!proto.risk.CreateOrUpdateRisksInternalRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.risk.CreateOrUpdateRisksInternalResponse>}
 *     Promise that resolves to the response
 */
proto.risk.RiskInternalServicePromiseClient.prototype.createOrUpdateRisks =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/risk.RiskInternalService/CreateOrUpdateRisks',
      request,
      metadata || {},
      methodDescriptor_RiskInternalService_CreateOrUpdateRisks);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.risk.ToggleRiskLinksInternalRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_RiskInternalService_ToggleRiskLinks = new grpc.web.MethodDescriptor(
  '/risk.RiskInternalService/ToggleRiskLinks',
  grpc.web.MethodType.UNARY,
  proto.risk.ToggleRiskLinksInternalRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.risk.ToggleRiskLinksInternalRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.risk.ToggleRiskLinksInternalRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.risk.RiskInternalServiceClient.prototype.toggleRiskLinks =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/risk.RiskInternalService/ToggleRiskLinks',
      request,
      metadata || {},
      methodDescriptor_RiskInternalService_ToggleRiskLinks,
      callback);
};


/**
 * @param {!proto.risk.ToggleRiskLinksInternalRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.risk.RiskInternalServicePromiseClient.prototype.toggleRiskLinks =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/risk.RiskInternalService/ToggleRiskLinks',
      request,
      metadata || {},
      methodDescriptor_RiskInternalService_ToggleRiskLinks);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.risk.SetRiskEvaluationCriteriaInternalRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_RiskInternalService_SetRiskEvaluationCriteria = new grpc.web.MethodDescriptor(
  '/risk.RiskInternalService/SetRiskEvaluationCriteria',
  grpc.web.MethodType.UNARY,
  proto.risk.SetRiskEvaluationCriteriaInternalRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.risk.SetRiskEvaluationCriteriaInternalRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.risk.SetRiskEvaluationCriteriaInternalRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.risk.RiskInternalServiceClient.prototype.setRiskEvaluationCriteria =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/risk.RiskInternalService/SetRiskEvaluationCriteria',
      request,
      metadata || {},
      methodDescriptor_RiskInternalService_SetRiskEvaluationCriteria,
      callback);
};


/**
 * @param {!proto.risk.SetRiskEvaluationCriteriaInternalRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.risk.RiskInternalServicePromiseClient.prototype.setRiskEvaluationCriteria =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/risk.RiskInternalService/SetRiskEvaluationCriteria',
      request,
      metadata || {},
      methodDescriptor_RiskInternalService_SetRiskEvaluationCriteria);
};


module.exports = proto.risk;

